let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("5aQ58")]).then(() => parcelRequire('adU7i'));